import React from "react";
import { findItemByName } from "../../../settings/utils/functions";

const BodyContents = ({ items, activeItem, data, setData }) => {
  const item = findItemByName(items, activeItem);
  const { Component } = item;

  return <div style={{ padding: "15px 0" }}>
    <Component data={data} setData={setData} />
  </div>;
};

export default BodyContents;
